// extracted by mini-css-extract-plugin
module.exports = {"card":"tRKncP63dcmJQOBqk8ffO"};